import React, { useState } from 'react';
import { Card, List, Button, Input, Form, Space, Modal, message } from 'antd';

const defaultTemplates = [
  {
    id: 1,
    name: '亚马逊高质量文案生成',
    content: '作为亚马逊运营专家，请模仿这个产品原标题[{product_title}]介绍，产品名称是[{product_name}] 产品卖点是:[{selling_points}] 产品核心关键词是需要抓取[{core_keywords}] 产品的高流量词，高转化词并出现在title的最佳位置。写出亚马逊title，包并要求标题中含高流量词，高转化词客户最关心的3个卖点、2个以上主要适应场景和客户购买欲望； 写出5条详细的bullet points,并要求bullet points内容中包含产品时尚，使用功能，展示产品的详情信息激励客户购买欲望； 写出product description，并要求product description中包含产品详情信息或易用，激励客户购买欲望；要求生成后的文案必须去掉亚马逊侵权词，请用（英文）输出英文',
    variables: ['product_title', 'product_name', 'selling_points', 'core_keywords']
  },
  {
    id: 2,
    name: '五点描述AI埋词',
    content: '你是一名资深的亚马逊卖家，你有着很强的逻辑与理解能力，请你根据我如下的输入进行亚马逊五点描述的编写。注意：必须把核心关键词都埋入到五点描述中；若输入商品描述不为空，编写内容则仿写输入的\'商品描述\'；若输入商品描述为空，则要明确划分五点；输出的内容只保存编写的五点描述。要求关键词注意埋入率，不要重复。输入内容:商品名称是：[{product_name}]；商品描述是：[{product_desc}]',
    variables: ['product_name', 'product_desc']
  }
];

const PromptGenerator = () => {
  const [templates, setTemplates] = useState(defaultTemplates);
  const [selected, setSelected] = useState(defaultTemplates[0]);
  const [form] = Form.useForm();
  const [result, setResult] = useState('');
  const [loading, setLoading] = useState(false);
  const [editing, setEditing] = useState(null);

  const handleSelect = (tpl) => {
    setSelected(tpl);
    form.resetFields();
    setResult('');
  };

  const handleEdit = (tpl) => {
    setEditing({ ...tpl });
  };

  const handleSave = () => {
    setTemplates(templates.map(t => t.id === editing.id ? editing : t));
    if (selected.id === editing.id) setSelected(editing);
    setEditing(null);
    message.success('模板已保存');
  };

  const handleGenerate = async () => {
    try {
      const values = await form.validateFields();
      setLoading(true);
      // TODO: 调用后端AI生成接口
      // const res = await axios.post('/api/ai-generate/', { template_id: selected.id, variables: values });
      // setResult(res.data.result);
      setTimeout(() => {
        setResult('【AI生成结果（mock）】\n' + JSON.stringify(values, null, 2));
        setLoading(false);
      }, 1000);
    } catch {}
  };

  return (
    <div style={{ display: 'flex', gap: 24 }}>
      <Card title="指令模板" style={{ width: 260, flexShrink: 0 }}>
        <List
          dataSource={templates}
          renderItem={tpl => (
            <List.Item
              style={{ cursor: 'pointer', background: selected.id === tpl.id ? '#e6f7ff' : undefined }}
              onClick={() => handleSelect(tpl)}
              actions={[
                <Button size="small" onClick={e => { e.stopPropagation(); handleEdit(tpl); }}>编辑</Button>
              ]}
            >
              {tpl.name}
            </List.Item>
          )}
        />
      </Card>
      <Card title="AI提示词生成" style={{ flex: 1 }}>
        <div style={{ marginBottom: 16 }}>
          <b>模板内容：</b>
          <div style={{ background: '#fafafa', padding: 12, borderRadius: 4, margin: '8px 0' }}>{selected.content}</div>
        </div>
        <Form form={form} layout="vertical" style={{ maxWidth: 500 }}>
          {selected.variables.map(v => (
            <Form.Item key={v} name={v} label={v} rules={[{ required: true, message: `请输入${v}` }]}> <Input /> </Form.Item>
          ))}
          <Form.Item>
            <Space>
              <Button type="primary" onClick={handleGenerate} loading={loading}>生成</Button>
              <Button onClick={() => setResult('')}>清空结果</Button>
            </Space>
          </Form.Item>
        </Form>
        <div style={{ marginTop: 24 }}>
          <b>生成结果：</b>
          <div style={{ minHeight: 80, background: '#f6f6f6', padding: 12, borderRadius: 4, whiteSpace: 'pre-wrap' }}>{result}</div>
        </div>
      </Card>
      <Modal
        open={!!editing}
        title="编辑模板"
        onOk={handleSave}
        onCancel={() => setEditing(null)}
      >
        <Input
          value={editing?.name}
          onChange={e => setEditing({ ...editing, name: e.target.value })}
          placeholder="模板名称"
          style={{ marginBottom: 8 }}
        />
        <Input.TextArea
          value={editing?.content}
          onChange={e => setEditing({ ...editing, content: e.target.value })}
          placeholder="模板内容"
          rows={6}
        />
      </Modal>
    </div>
  );
};

export default PromptGenerator; 